const createOrUpdateUserAddressDetailsGraphQlMutation = (
  withMutation = true
): { mutation: string; type: string } => {
  const failureFields = `
    failure_response {
      res_status
      response
    }
  `;

  const successFields = `
    completion_percentage
  `;

  const mutation = `create_or_update_user_address_details(user_address_details_input: $user_address_details_input) {
          ${successFields}
          ${failureFields}
        }`;

  if (withMutation)
    return {
      mutation: `
    mutation CreateOrUpdateUserAddressDetails($user_address_details_input: UserAddressDetailsInput!) {
      ${mutation}
    }
  `,
      type: 'UserAddressDetailsInput!'
    };
  else return { mutation, type: 'UserAddressDetailsInput!' };
};

export { createOrUpdateUserAddressDetailsGraphQlMutation };
